
import { CurrencyApi } from "@/api/CurrencyApi";
import { FormConfigType } from "@/types/dynamicForm";
import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { generateCurrencyOptionLabel } from "@utils/Currency";
import { CurrencyIdPubSub } from "@utils/pubsubs/PubSub";

const ExpenseFormConfig: FormConfigType = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "hidden",
                        "name": "tipo",
                    },
                    {
                        "type": "hidden",
                        "name": "expenseId",
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "excluir_reporte",
                        "label": "Excluir de Reporte",
                        "sizing": {
                            "sm": {
                                "offset": 2
                            }
                        }
                    }
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "currencyId",
                        "label": "Moneda",
                        "optionsFunction": () => CurrencyApi.optionsList({}, (i) => generateCurrencyOptionLabel(i)),
                        "onChangePubSub": (value: string) => CurrencyIdPubSub.publish({ currencyId: value }),
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "date",
                        "name": "fecha",
                        "label": "Fecha",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "number",
                        "name": "sequence",
                        "label": "Numero Consecutivo",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 4
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "document_key",
                        "label": "Clave Numerica",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 6
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "numero",
                        "label": "Numero Nota",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 4
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                    },
                ],
                [
                    {
                        "type": "number",
                        "name": "exchange_rate",
                        "label": "Tipo de Cambio",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "subtotal",
                        "label": "Subtotal",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "descuento",
                        "label": "Descuento",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "impuestos",
                        "label": "Impuestos",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "total",
                        "label": "Total",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ]
            ]
        }
    ],
};


export default ExpenseFormConfig;